import { Column} from 'react-table'
import { DLMLabellingActionsCell } from './DLMLabellingActionsCell'
import { ShowDateCell, ApplicationStateCell, MarkerBadge } from '../../../../../../../components/widgets'
import { DLMSiteApplication } from '../../../../_models'
import { DLMApplicationTerminationStates } from '../../../../_constants'
import { DLMLabellingROICell } from './DLMLabellingROICell'
import { DLMLabellingNotesCell } from './DLMLabellingNotesCell'
import { DLMLabellingNotesHeaderCell } from './DLMLabellingNotesHeaderCell'
import { PropsWithNotes } from '../../../../../../../components/table'

const DLMLabellingColumns: ReadonlyArray<Column<PropsWithNotes<DLMSiteApplication>>> = [
  {
    Header: 'Actions',
    minWidth: 120,    
    id: 'actions',
    Cell: ({...props}) => <DLMLabellingActionsCell
      site={props.data[props.row.index]}
    />,
  },
  {
    Header: 'State',
    minWidth: 80,
    id: 'state',
    Cell: ({...props}) => 
    <div className="d-flex flex-row align-items-center gap-1">            
      <ApplicationStateCell state_val={props.data[props.row.index].state} className='min-w-225px' />
      <MarkerBadge state={props.data[props.row.index].requestTerminateState} states={DLMApplicationTerminationStates} />            
    </div>
  },
  {
    Header: <DLMLabellingNotesHeaderCell />,
    minWidth: 20,
    id: 'notes',
    Cell: ({...props}) => <DLMLabellingNotesCell row={props.data[props.row.index]} />,
  },    
  {
    Header: 'Project Name',
    minWidth: 125,    
    accessor: 'projectName',
  },    
  {
    Header: 'Client Ref No',
    minWidth: 80,    
    accessor: 'clientRefNo',
  },
  {
    Header: 'Site Labelling Date',
    minWidth: 125,    
    id: 'inspectionDate',
    Cell: ({...props}) => <ShowDateCell date_val={props.data[props.row.index].inspectionDate} />,
  },
  {
    Header: 'ROI',
    minWidth: 125,    
    id: 'roiFiles',
    Cell: ({...props}) => <DLMLabellingROICell site={props.data[props.row.index]} />,
  },
  {
    Header: 'Last Update',
    minWidth: 125,  
    id: 'dteUpd',
    Cell: ({...props}) => <ShowDateCell date_val={props.data[props.row.index].dteUpd} />,
  },
]

export {DLMLabellingColumns}
